import React, { Component } from 'react';
import * as VK from '@vkontakte/vkui';
import { authUser } from "./js/services/auth";
import { connect } from 'react-redux';
import '@vkontakte/vkui/dist/vkui.css';
import { popHistory } from "./js/store/globals/actions";
import {goBack, push} from "react-router-redux";
import RoutesAndPanels from "./js/classes/_RoutesAndPanels";
import { setMockData } from "./js/services/mock";
import '../src/css/style.css'
import {initApp} from "./js/services/vk";
import {getBills, getTodaySum} from "./js/services/db";
import {setBills, setEndReached, setTodaySum} from "./js/store/bills/actions";
import ModalInfoCard from "./js/components/ModalInfoCard";


class App extends Component {

    async componentWillMount() {
        // DEVMOCK
        if (process.env.NODE_ENV === 'development') setMockData();

        // Авторизуем кассира
        await this.props.dispatch(authUser());

        // Если авторизовать не удалось
        if (this.props.status === false) {
            this.props.dispatch(push('/wrong-user'));
            setTimeout(() => this.props.dispatch(initApp()), 1000);
        } else {
            if (this.props.cashier.cashier_id !== undefined) {
                this.props.dispatch(initApp());
                const bills = await this.props.dispatch(getBills(this.props.cashier.cashier_id, this.props.limit, 0));
                if (bills.result !== undefined && bills.result === 'success') {
                    this.props.dispatch(setBills(bills.data.data.data));
                    if (bills.data.data.data.length < this.props.limit) this.props.dispatch(setEndReached());

                    // Сумма платежей сегодня
                    const getSumResult = await getTodaySum(this.props.cashier.cashier_id);
                    if (getSumResult.data !== undefined && getSumResult.data.data !== undefined && getSumResult.data.data.sum !== undefined) this.props.dispatch(setTodaySum(getSumResult.data.data.sum, getSumResult.data.data.refundSum,));
                } else {
                    this.props.dispatch(setBills([]));
                }
            } else {
                this.props.dispatch(push('/wrong-user'));
                setTimeout(() => this.props.dispatch(initApp()), 1000);
            }
        }
    }

    async swipeBack() {
        this.props.dispatch(goBack());
        this.props.dispatch(popHistory());
    }

    render() {
        let panel = RoutesAndPanels.sharedInstance.getSelectedPanel(this.props.pageId);

        return (
            <VK.ConfigProvider isWebView={ true } >
                <VK.Root activeView="mainView">
                    <VK.View
                        id="mainView"
                        activePanel={ panel }
                        history={ this.props.history }
                        popout={ this.props.popout }
                        onSwipeBack={ () => this.swipeBack() }
                        modal={ <ModalInfoCard/> }
                    >
                        { RoutesAndPanels.sharedInstance.renderPanels() }
                    </VK.View>
                </VK.Root>
            </VK.ConfigProvider>
        );
    }
}

function mapStateToProps(state) {
    return {
        history: state.globals.history,
        popout: state.globals.popout,
        modal: state.globals.modal,
        status: state.cashier.status,
        cashier: state.cashier.cashier,
        limit: state.bills.limit,
    };
}

export default connect(mapStateToProps)(App);


// WEBPACK FOOTER //
// ./src/App.js